<template>
  <path
    id="ic_wifi_24px"
    d="M1,9l2,2a12.729,12.729,0,0,1,18,0l2-2A15.566,15.566,0,0,0,1,9Zm8,8,3,3,3-3A4.237,4.237,0,0,0,9,17ZM5,13l2,2a7.074,7.074,0,0,1,10,0l2-2A9.91,9.91,0,0,0,5,13Z"
    transform="translate(-1 -4.448)" />
</template>
